export default "__VITE_ASSET__BvqwIYUF__"